import $store from '@/store'

export default [
  {
    name: 'signin',
    path: '/signin',
    meta: {
      requireSignin: false,
      ui: {
        newHeader: true,
        header: {
          backButton: true,
          title: '로그인',
        },
        classes: ['px-0'],
      },
    },
    beforeEnter(to, from, next) {
      if ($store.getters['auth/isAuthenticated']) {
        next({ name: 'main' })
      } else {
        next()
      }
    },
    component() {
      return import('@/pages/signin/Signin.vue')
    },
  },
]
